// extracted by mini-css-extract-plugin
export default {"other":"index_other_o-J4c","judgesImg":"index_judgesImg_CWouG"};